import { Link } from "react-router";

interface ArticleSeriesListProps {
  series: Array<{
    id: string;
    title: string;
    urlSlug: string;
    description?: string;
    articleCount?: number | null;
  }>;
}

export function ArticleSeriesList({ series }: ArticleSeriesListProps) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
      {series.map((item) => (
        <Link
          key={item.id}
          to={`/learn/series/${item.urlSlug}`}
          className="block bg-white p-4 border border-border rounded-lg hover:border-blue-500 hover:shadow-sm transition-shadow text-gray-700 hover:text-blue-800"
        >
          <h4 className="font-semibold text-lg mb-2 ">{item.title}</h4>
          {item.description && (
            <p className="text-gray-600 text-sm line-clamp-2">
              {item.description}
            </p>
          )}
          {item.articleCount && (
            <p className="text-sm text-gray-500 mt-2">
              {item.articleCount} article{item.articleCount !== 1 ? "s" : ""}
            </p>
          )}
        </Link>
      ))}
    </div>
  );
}
